module.exports = __webpack_public_path__ + "static/media/gai.bf287f2b.ogg";